// extracted by mini-css-extract-plugin
export default {"notice":"src-modules-core-components-Notice-style__notice_aSNnQ"};